import React from 'react'
import './Button.css'
import './Item.css'
import { useStateValue } from './StateProvider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import AffiliateLink from './AffiliateLink'

const Item = ({ 
  productId,
  image, 
  prodName, 
  price, 
  originalPrice, 
  brand, 
  description, 
  inStock, 
  rating, 
  reviews,
  affiliateLink
}) => {
  const [{ basket }, dispatch] = useStateValue()

  const addToBasket = () => {
    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        image: image,
        prodName: prodName,
        price: price,
        brand: brand,
        description: description,
      },
    })
  }

  const renderStars = (rating) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 !== 0

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FontAwesomeIcon key={i} icon={faStar} className="star filled" />)
    }
    
    if (hasHalfStar) {
      stars.push(<FontAwesomeIcon key="half" icon={faStar} className="star half" />)
    }
    
    const emptyStars = 5 - Math.ceil(rating)
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FontAwesomeIcon key={`empty-${i}`} icon={faStar} className="star empty" />)
    }
    
    return stars
  }

  return (
    <div className="item">
      <div className="item-image-container">
        <img className="prod prod-image" src={image} alt={prodName}></img>
        {!inStock && <div className="out-of-stock">Slut i lager</div>}
        {originalPrice && originalPrice > price && (
          <div className="sale-badge">REA</div>
        )}
      </div>
      
      <div className="item-info">
        <p className="prod prod-brand">{brand}</p>
        <p className="prod prod-name">{prodName}</p>
        
        <div className="rating-container">
          <div className="stars">
            {renderStars(rating)}
          </div>
          <span className="rating-text">({reviews})</span>
        </div>
        
        <div className="price-container">
          <p className="prod prod-price">{price} kr</p>
          {originalPrice && originalPrice > price && (
            <p className="prod prod-original-price">{originalPrice} kr</p>
          )}
        </div>
        
        <p className="prod prod-description">{description}</p>
        
        {inStock ? (
          <a
            href={affiliateLink || 'https://leksaksbilar.se'}
            target="_blank"
            rel="noopener noreferrer"
            className="buy-button"
            onClick={() => {
              console.log('Affiliate click tracked:', {
                productId,
                productName: prodName,
                price,
                timestamp: new Date().toISOString()
              });
            }}
          >
            <FontAwesomeIcon icon={faShoppingCart} />
            Köp hos Leksaksbilar.se
          </a>
        ) : (
          <button className="buy-button disabled" disabled>
            <FontAwesomeIcon icon={faShoppingCart} />
            Slut i lager
          </button>
        )}
      </div>
    </div>
  )
}

export default Item
